/* istanbul ignore file */
import { array as codecArray, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const NewAutoTestUbuntu2404BaseImageIdsSettingParser = 
/* #__PURE__ */ parsers.object([
    [
        'name',
        /* #__PURE__ */ parsers.exactly('NEW_AUTO_TEST_UBUNTU_24_04_BASE_IMAGE_IDS'),
    ],
    [
        'value',
        /* #__PURE__ */ parsers.maybeNull(/* #__PURE__ */ codecArray(codecString)),
    ],
]);
export class NewAutoTestUbuntu2404BaseImageIdsSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return NewAutoTestUbuntu2404BaseImageIdsSettingParser.decode(input).map(res => new NewAutoTestUbuntu2404BaseImageIdsSetting(res));
    }
    static unsafeDecode(input) {
        return NewAutoTestUbuntu2404BaseImageIdsSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NewAutoTestUbuntu2404BaseImageIdsSettingParser.encode(data);
    }
    static schema() {
        return NewAutoTestUbuntu2404BaseImageIdsSettingParser.schema();
    }
}
